// src/index.jsx
// ENTRY FILE – Spark plan (no require, no CommonJS)
// If you still see "require is not defined" after this file,
// then the browser is not loading THIS file.

import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { HelmetProvider } from "react-helmet-async";

import routes from "./routes.jsx";
import { AuthProvider } from "./context/AuthContext.jsx";

// 1) Initialize Firebase first (side effects only)
import "./firebase/firebase.jsx";

// 2) Then i18n (may depend on Firebase)
import i18n from "./i18n.jsx";

// 3) Global styles last
import "./styles/main.css";

// DEBUG MARKER: helps us confirm this file is the one actually running
console.log("[index.jsx] React entry loaded");

// Router with v7 future flags
const router = createBrowserRouter(routes, {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true,
  },
});

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("❌ Root element #root not found in index.html");
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <HelmetProvider>
      <I18nextProvider i18n={i18n}>
        <AuthProvider>
          <Suspense
            fallback={
              <divz style={{ padding: 16 }} aria-live="polite">
                Loading…
              </divz>
            }
          >
            <RouterProvider router={router} />
          </Suspense>
        </AuthProvider>
      </I18nextProvider>
    </HelmetProvider>
  </React.StrictMode>
);
